import React, { Component } from 'react'
import PropTypes from 'prop-types'
import orgamax from 'ampersand-app'
import { FormikContext } from 'formik'

import settingsConfig from '@/modules/settings/config'
import SelectInput from '@/modules/base/components/inputs/select-input/select-input'
import lang from '@/lang'
import { getMiscellaneousData } from '@/modules/base/helpers/getSettingsData'

import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

class SalutationInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldRefresh: false,
      menuIsOpen: false,
    }

    this.salutations = []
    this.getSalutations = this.getSalutations.bind(this)
    this.onSalutationChange = this.onSalutationChange.bind(this)
    this.onSalutationCreated = this.onSalutationCreated.bind(this)
    this.getSalutationSelectProps = this.getSalutationSelectProps.bind(this)
    this.openMenu = this.openMenu.bind(this)
    this.onMenuClose = this.onMenuClose.bind(this)
  }

  componentDidMount() {
    if (this.props.defaultMenuIsOpen) {
      this.refs.getSelectInput().focus()
      this.openMenu()
    }
  }

  openMenu() {
    this.setState({ ...this.state, menuIsOpen: true })
  }

  onMenuClose() {
    this.setState({ ...this.state, menuIsOpen: false })
  };

  getSalutations(search) {
    return getMiscellaneousData()
      .then((response) => {
        const { body: { data: { salutations } } } = response
        this.salutations = salutations

        const mappedSalutations = salutations
          .map(salutation => ({ name: salutation }))

        if (search) {
          return mappedSalutations.filter(salutation => salutation.name.toLowerCase().includes(search.toLowerCase()))
        }

        return mappedSalutations
      })
  }

  getSalutationSelectProps() {
    const { isInline, customClass, useFormik } = this.props

    const name = 'salutation'
    const fieldMeta = useFormik === undefined || useFormik ? this.context?.getFieldMeta(name) : null
    const value = fieldMeta ? fieldMeta.value : this.props.value

    return {
      label: 'Anrede',
      name,
      allowCreate: true,
      notAsync: false,
      containerClass: customClass,
      isInline,
      customSelectOptions: {
        placeholder: lang.selectInput.createPlaceholder,
        valueKey: 'name',
        labelKey: 'name',
        isClearable: true,
        loadOptions: this.getSalutations,
        defaultOptions: true,
        menuIsOpen: this.state.menuIsOpen,
      },
      value: value ? { name: value } : '',
      handleChange: this.onSalutationChange,
      onOptionCreated: this.onSalutationCreated,
      handleMenuClose: this.onMenuClose,
      useFormik: false,
      onFocus: this.openMenu,
      onBlur: () => {
        this.onMenuClose()
      },
    }
  }

  onSalutationChange(option) {
    const { onChange } = this.props
    onChange && onChange(option ? option.name : '')
    this.onMenuClose()
  }

  onSalutationCreated(option) {
    const newSalutations = [...this.salutations, option]

    request(settingsConfig.contact, {
      auth: true,
      method: 'POST',
      data: { salutations: newSalutations },
    })
      .then(() => {
        toast.showToast({ message: lang.contactPersonForm.salutation.optionCreated(option) })
        this.salutations = newSalutations
        this.onSalutationChange({ name: option })
        this.setState((prevState) => ({ shouldRefresh: !prevState.shouldRefresh }))
      })
  }

  render() {
    // necessary for refreshing options if a new one was created
    const { shouldRefresh } = this.state
    const { dataQsId } = this.props
    const salutationSelectProps = this.getSalutationSelectProps()

    return (
      <SelectInput dataQsId={dataQsId} ref={select => (this.refs = select)} customKey={shouldRefresh} {...salutationSelectProps} />
    )
  }
}

SalutationInput.contextType = FormikContext

SalutationInput.propTypes = {
  value: PropTypes.string,
  isInline: PropTypes.bool,
  useFormik: PropTypes.bool,
  defaultMenuIsOpen: PropTypes.bool,
  onChange: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
}

SalutationInput.defaultProps = {
  isInline: false,
  defaultMenuIsOpen: false,
}

export default SalutationInput
